import React from 'react'

function NewHomecomponent() {
  return (
    <>
<div className="home-full hometext-wrap new-design">
  <div className="container">
    <div className="hometext-tab">
      <h2>Why should <em>she</em> have to fit in? <br />
        <span>The outfit should fit <em>her!</em></span></h2>
      <p>We believe finding something beautiful is only the beginning. <br />
        The right outfit is one that feels right on <em>her</em> — in the way it fits, moves, flatters and makes <em>her</em> feel.</p>
      <p>Made for <em>her</em>, <em>her</em> way.</p>
      <p><span>That’s what Chaashni is about.</span></p>
      <div className="lotas-box"><img src="images/about/Lotus-pink.png" alt="" /></div>
    </div>
  </div>
</div>
<div className="about-chaashni-full new-design">
  <span className='newscroll-box' id="about-box">&nbsp;</span>
  <div className="container">
    <div className="hometext-tab">
      <h2>About Chaashni & the Founders</h2>
      <p>Founded by Maansi and Ketan, Chaashni is a passion project rooted in elegance and artistry.</p>
      <p>Every woman is different — <br />
        her body, complexion, personality and idea of what makes her feel beautiful. <br />
        At Chaashni, we understand, guide, create and curate to help <em>her</em> find an outfit that feels truly made for <em>her</em>.</p>
      {/* <p>Behind that experience is a team that brings together design, craftsmanship and personal attention.</p> */}
      <p>Here's more about them and the team behind Chaashni.</p>
      <ul className="about-section">
        <li className="foursection">
            <div className="foursection-box border-img"><a href="#"><img src="/images/newhome/the-brand-manifesto.png" alt="The Brand Manifesto" /></a></div>
            <div className="foursection-box border-img"><a href="#"><img src="/images/newhome/the-why-of-chaashni.png" alt="The Why of Chaashni" /></a></div>
            <div className="foursection-box"><a href="/aboutchaashni#peopleofchaashni"><img src="/images/newhome/people-of-chaashni.png" alt="The People of Chaashni" /></a><p><a href="/aboutchaashni#peopleofchaashni">The People of Chaashni</a></p></div>
            <div className="foursection-box"><a href="/clientdiaries"><img src="/images/newhome/women-in-chaashni.png" alt="The Women Chaashni" /></a><p><a href="/clientdiaries">Women of Chaashni</a></p></div>
        </li>
        <li className="mk-img">
          <a href="/aboutchaashni#maansiketan"><img src="/images/newhome/mk.png" alt="MaansiAndKetan" /></a>
          <p><a href="/aboutchaashni#maansiketan">About Maansi &amp; Ketan</a></p>
        </li>
        <li className="foursection">
            <div className="foursection-box border-img"><a href="#storenew-box"><img src="/images/newhome/flagship-stores.png" alt="Flagship Stores" /></a></div>
            <div className="foursection-box border-img"><a href="/reviews"><img src="/images/newhome/reviews.png" alt="Reviews" /></a></div>
            <div className="foursection-box"><a href="/celebrity"><img src="/images/newhome/celebrities-in-chaashni.png" alt="Celebrities in Chaashni" /></a><p><a href="/celebrity">Celebrities in Chaashni</a></p></div>
            <div className="foursection-box"><a href="/clientdiaries"><img src="/images/newhome/women-in-chaashni.png" alt="The Women Chaashni" /></a><p><a href="/clientdiaries">Women of Chaashni</a></p></div>
        </li>
      </ul>      
    </div>
  </div>
</div>
<div className="reachus-section new-design">
  <div className="container">
    <h2>Whenever <em>she</em> is ready, we’re here.</h2>
    <p>Whether <em>she</em> knows exactly what <em>she</em> wants — or would like a little help — we’ll meet <em>her</em> there.</p>
    <ul>
      <li><a href="https://chaashnicouture.com/book-appointment/" target="_blank"><img src='/images/newhome/localtion-icon.png' alt='' /> <span>BOOK A STORE APPOINTMENT</span></a></li>
      <li><a rel="noopener noreferrer" href="https://wa.me/+919582475486" target="_blank"><img src='/images/newhome/call-icon.png' alt='' /> TALK TO A STYLIST</a></li>
      <li><a href="#"><img src='/images/newhome/localtion-icon.png' alt='' /> MEET OVER VIDEO</a></li>
      <li className='shop-collection'><a href="/made-for-her"><span>SHOP <em>the</em> COLLECTION</span></a></li>
    </ul>
  </div>
</div>


    </>
  )
}

export default NewHomecomponent
